var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-detail-container",
    },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "header-content" }, [
          _c("div", { staticClass: "title-section" }, [
            _vm._m(0),
            _c("p", { staticClass: "page-subtitle" }, [
              _vm._v("订单号：" + _vm._s(_vm.orderDetail.orderNo)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _vm.orderDetail.status === 3
                ? _c(
                    "el-button",
                    {
                      staticClass: "refund-btn",
                      attrs: {
                        type: "danger",
                        size: "medium",
                        icon: "el-icon-refresh-left",
                      },
                      on: { click: _vm.showRefundDialog },
                    },
                    [_vm._v(" 退款 ")]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  staticClass: "back-btn",
                  attrs: { size: "medium", icon: "el-icon-back" },
                  on: { click: _vm.goBack },
                },
                [_vm._v(" 返回 ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "el-card",
        { staticClass: "status-card", attrs: { shadow: "hover" } },
        [
          _c("div", { staticClass: "status-content" }, [
            _c(
              "div",
              { staticClass: "status-item" },
              [
                _c("span", { staticClass: "status-label" }, [
                  _vm._v("订单状态"),
                ]),
                _c(
                  "el-tag",
                  {
                    staticClass: "status-tag",
                    attrs: {
                      type: _vm.getStatusTagType(_vm.orderDetail.status),
                      effect: "dark",
                      size: "medium",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getStatusText(_vm.orderDetail.status)) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "status-divider" }),
            _c("div", { staticClass: "status-item" }, [
              _c("span", { staticClass: "status-label" }, [_vm._v("创建时间")]),
              _c("span", { staticClass: "status-value" }, [
                _vm._v(
                  _vm._s(_vm.formatCreateTime(_vm.orderDetail.createTime))
                ),
              ]),
            ]),
            _c("div", { staticClass: "status-divider" }),
            _c("div", { staticClass: "status-item" }, [
              _c("span", { staticClass: "status-label" }, [_vm._v("订单渠道")]),
              _c("span", { staticClass: "status-value" }, [
                _vm._v(
                  _vm._s(_vm.getOrderChannelText(_vm.orderDetail.orderChannel))
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "info-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" 基本信息 "),
              ]),
            ]
          ),
          _c(
            "el-descriptions",
            {
              staticClass: "custom-descriptions",
              attrs: { column: 3, border: "" },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "采购订单号" } }, [
                _vm._v(_vm._s(_vm.orderDetail.purchaseOrderNo || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "订单来源" } }, [
                _vm._v(_vm._s(_vm.orderDetail.orderSource || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "供应商" } }, [
                _vm._v(_vm._s(_vm.orderDetail.supplierName || "-")),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "flight-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-plane" }),
                _vm._v(" 航班信息 "),
              ]),
            ]
          ),
          !_vm.orderDetail.flightInfoList ||
          !_vm.orderDetail.flightInfoList.length
            ? _c("div", { staticClass: "empty-state" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _c("span", [_vm._v("暂无航班信息")]),
              ])
            : _c(
                "div",
                { staticClass: "flight-list" },
                _vm._l(
                  _vm.orderDetail.flightInfoList,
                  function (flight, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flight-item" },
                      [
                        _c("div", { staticClass: "flight-number" }, [
                          _vm._v(_vm._s(flight.flightNo)),
                        ]),
                        _c("div", { staticClass: "flight-route" }, [
                          _c("div", { staticClass: "city-info" }, [
                            _c("div", { staticClass: "city-name" }, [
                              _vm._v(_vm._s(flight.departureCity)),
                            ]),
                            _c("div", { staticClass: "flight-time" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatFlightTime(flight.departureTime)
                                )
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "flight-arrow" }, [
                            _c("i", { staticClass: "el-icon-d-arrow-right" }),
                          ]),
                          _c("div", { staticClass: "city-info" }, [
                            _c("div", { staticClass: "city-name" }, [
                              _vm._v(_vm._s(flight.arriveCity)),
                            ]),
                            _c("div", { staticClass: "flight-time" }, [
                              _vm._v(
                                _vm._s(_vm.formatFlightTime(flight.arriveTime))
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    )
                  }
                ),
                0
              ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "passenger-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-user" }),
                _vm._v(" 乘机人信息 "),
              ]),
            ]
          ),
          _c(
            "el-table",
            {
              staticClass: "custom-table",
              attrs: {
                data: _vm.orderDetail.passengerInfoList || [],
                border: "",
                stripe: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "姓名",
                  prop: "name",
                  width: "150px",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "证件类型",
                  prop: "idCardTye",
                  width: "120px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.getIdCardTypeText(scope.row.idCardTye))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "证件号",
                  prop: "idCardNo",
                  "min-width": "200px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.idCardNo || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "乘客类型",
                  prop: "passengerType",
                  width: "100px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "small",
                              type:
                                scope.row.passengerType === 0
                                  ? "primary"
                                  : scope.row.passengerType === 1
                                  ? "success"
                                  : "warning",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getPassengerTypeText(
                                    scope.row.passengerType
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "票号",
                  prop: "ticketNo",
                  width: "180px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.ticketNo || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "证件有效期",
                  prop: "certificateEffectTime",
                  width: "140px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.formatCertTime(scope.row.certificateEffectTime)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "contact-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-phone" }),
                _vm._v(" 联系人信息 "),
              ]),
            ]
          ),
          _c(
            "el-descriptions",
            {
              staticClass: "custom-descriptions",
              attrs: { column: 3, border: "" },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "联系人姓名" } }, [
                _vm._v(
                  _vm._s(
                    (_vm.orderDetail.contacts &&
                      _vm.orderDetail.contacts.name) ||
                      "-"
                  )
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "手机号" } }, [
                _vm._v(
                  _vm._s(
                    (_vm.orderDetail.contacts &&
                      _vm.orderDetail.contacts.phone) ||
                      "-"
                  )
                ),
              ]),
              _c("el-descriptions-item", { attrs: { label: "邮箱" } }, [
                _vm._v(
                  _vm._s(
                    (_vm.orderDetail.contacts &&
                      _vm.orderDetail.contacts.email) ||
                      "-"
                  )
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "price-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-wallet" }),
                _vm._v(" 价格明细 "),
              ]),
              _c(
                "div",
                { staticClass: "currency-badge" },
                [
                  _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                    _vm._v(
                      _vm._s(_vm.orderDetail.currencyName || "-") +
                        "（" +
                        _vm._s(_vm.orderDetail.currency || "-") +
                        "）"
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          !_vm.orderDetail.priceInfo
            ? _c("el-empty", {
                attrs: { description: "暂无价格信息", "image-size": 80 },
              })
            : _c(
                "div",
                { staticClass: "price-content" },
                [
                  _c(
                    "el-row",
                    { staticClass: "price-row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("成人票价"),
                          ]),
                          _c("div", { staticClass: "price-value" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.currencySymbol || "") +
                                _vm._s(
                                  _vm.orderDetail.priceInfo.adultPrice || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("成人税费"),
                          ]),
                          _c("div", { staticClass: "price-value" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.currencySymbol || "") +
                                _vm._s(
                                  _vm.orderDetail.priceInfo.adultTax || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("成人数量"),
                          ]),
                          _c("div", { staticClass: "price-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.orderDetail.priceInfo.adultCount || "-"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm.orderDetail.priceInfo.childCount
                    ? _c(
                        "el-row",
                        { staticClass: "price-row", attrs: { gutter: 20 } },
                        [
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "price-item" }, [
                              _c("div", { staticClass: "price-label" }, [
                                _vm._v("儿童票价"),
                              ]),
                              _c("div", { staticClass: "price-value" }, [
                                _vm._v(
                                  _vm._s(_vm.orderDetail.currencySymbol || "") +
                                    _vm._s(
                                      _vm.orderDetail.priceInfo.childPrice ||
                                        "-"
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "price-item" }, [
                              _c("div", { staticClass: "price-label" }, [
                                _vm._v("儿童税费"),
                              ]),
                              _c("div", { staticClass: "price-value" }, [
                                _vm._v(
                                  _vm._s(_vm.orderDetail.currencySymbol || "") +
                                    _vm._s(
                                      _vm.orderDetail.priceInfo.childTax || "-"
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 8 } }, [
                            _c("div", { staticClass: "price-item" }, [
                              _c("div", { staticClass: "price-label" }, [
                                _vm._v("儿童数量"),
                              ]),
                              _c("div", { staticClass: "price-value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.orderDetail.priceInfo.childCount || "-"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    { staticClass: "price-row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("辅营费用"),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "price-value",
                              class: {
                                "negative-amount":
                                  _vm.orderDetail.priceInfo.auxiliaryPrice < 0,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.orderDetail.priceInfo.auxiliaryPrice &&
                                      _vm.orderDetail.priceInfo.auxiliaryPrice <
                                        0
                                      ? ""
                                      : _vm.orderDetail.currencySymbol || ""
                                  ) +
                                  _vm._s(
                                    _vm.orderDetail.priceInfo.auxiliaryPrice ||
                                      "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("票价（总）"),
                          ]),
                          _c("div", { staticClass: "price-value" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.currencySymbol || "") +
                                _vm._s(
                                  _vm.orderDetail.priceInfo.ticketTotalPrice ||
                                    "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("div", { staticClass: "price-item" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("税费（总）"),
                          ]),
                          _c("div", { staticClass: "price-value" }, [
                            _vm._v(
                              _vm._s(_vm.orderDetail.currencySymbol || "") +
                                _vm._s(
                                  _vm.orderDetail.priceInfo.taxPrice || "-"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { staticClass: "price-row", attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "price-item total-price" }, [
                          _c("div", { staticClass: "price-label" }, [
                            _vm._v("订单总价"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "price-value total-value" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.orderDetail.currencySymbol || "") +
                                  _vm._s(
                                    _vm.orderDetail.priceInfo.totalPrice || "-"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "payment-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-bank-card" }),
                _vm._v(" 账单流水 "),
              ]),
            ]
          ),
          !_vm.orderDetail.paymentInfoList ||
          !_vm.orderDetail.paymentInfoList.length
            ? _c("el-empty", {
                attrs: { description: "暂无账单流水", "image-size": 80 },
              })
            : _c(
                "el-table",
                {
                  staticClass: "custom-table",
                  attrs: {
                    data: _vm.orderDetail.paymentInfoList,
                    border: "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "支付流水号",
                      prop: "paymentFlow",
                      "min-width": "180px",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "交易类型",
                      prop: "cashRebateType",
                      width: "120px",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.getTransactionTagType(
                                    scope.row.cashRebateType
                                  ),
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getCashRebateTypeText(
                                        scope.row.cashRebateType
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "支付方式",
                      prop: "payWay",
                      width: "120px",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              { attrs: { type: "info", size: "small" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.getPayWayText(scope.row.payWay))
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "金额",
                      prop: "payAmount",
                      width: "140px",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  scope.row.payAmount < 0
                                    ? "negative-amount"
                                    : "positive-amount",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.payAmount &&
                                        scope.row.payAmount < 0
                                        ? ""
                                        : _vm.orderDetail.currencySymbol || ""
                                    ) +
                                    _vm._s(scope.row.payAmount || "-") +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "交易时间",
                      prop: "createTime",
                      width: "180px",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "log-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "card-title" }, [
                _c("i", { staticClass: "el-icon-edit-outline" }),
                _vm._v(" 操作日志 "),
              ]),
            ]
          ),
          !_vm.orderDetail.opLogList || !_vm.orderDetail.opLogList.length
            ? _c("el-empty", {
                attrs: { description: "暂无操作日志", "image-size": 80 },
              })
            : _c(
                "el-table",
                {
                  staticClass: "custom-table",
                  attrs: {
                    data: _vm.orderDetail.opLogList,
                    border: "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "序号",
                      width: "80px",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作类型",
                      prop: "operationType",
                      width: "150px",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作时间",
                      prop: "operationTime",
                      width: "180px",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作人",
                      prop: "operator",
                      width: "120px",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "备注",
                      prop: "remark",
                      "min-width": "200px",
                      align: "center",
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
      _vm.orderDetail.auxiliaryInfoList &&
      ((_vm.orderDetail.auxiliaryInfoList.baggage &&
        _vm.orderDetail.auxiliaryInfoList.baggage.length) ||
        (_vm.orderDetail.auxiliaryInfoList.seat &&
          _vm.orderDetail.auxiliaryInfoList.seat.length) ||
        (_vm.orderDetail.auxiliaryInfoList.meal &&
          _vm.orderDetail.auxiliaryInfoList.meal.length))
        ? _c(
            "el-card",
            { staticClass: "auxiliary-card", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", { staticClass: "card-title" }, [
                    _c("i", { staticClass: "el-icon-suitcase" }),
                    _vm._v(" 辅营信息 "),
                  ]),
                ]
              ),
              _c(
                "el-tabs",
                { staticClass: "custom-tabs", attrs: { type: "border-card" } },
                [
                  _vm.orderDetail.auxiliaryInfoList.baggage &&
                  _vm.orderDetail.auxiliaryInfoList.baggage.length
                    ? _c(
                        "el-tab-pane",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("i", {
                                staticClass: "el-icon-shopping-bag-1",
                              }),
                              _vm._v(" 行李 "),
                            ]
                          ),
                          _c(
                            "el-table",
                            {
                              staticClass: "custom-table",
                              attrs: {
                                data: _vm.orderDetail.auxiliaryInfoList.baggage,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "乘机人",
                                  prop: "passengerName",
                                  width: "150px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "行李重量",
                                  prop: "baggageWeight",
                                  width: "120px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "价格",
                                  prop: "price",
                                  width: "120px",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(scope.row.price || "-")
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1787087901
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderDetail.auxiliaryInfoList.seat &&
                  _vm.orderDetail.auxiliaryInfoList.seat.length
                    ? _c(
                        "el-tab-pane",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("i", { staticClass: "el-icon-seat" }),
                              _vm._v(" 选座 "),
                            ]
                          ),
                          _c(
                            "el-table",
                            {
                              staticClass: "custom-table",
                              attrs: {
                                data: _vm.orderDetail.auxiliaryInfoList.seat,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "乘机人",
                                  prop: "passengerName",
                                  width: "150px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "座位号",
                                  prop: "seatNo",
                                  width: "120px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "价格",
                                  prop: "price",
                                  width: "120px",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(scope.row.price || "-")
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1787087901
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.orderDetail.auxiliaryInfoList.meal &&
                  _vm.orderDetail.auxiliaryInfoList.meal.length
                    ? _c(
                        "el-tab-pane",
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("i", { staticClass: "el-icon-food" }),
                              _vm._v(" 餐食 "),
                            ]
                          ),
                          _c(
                            "el-table",
                            {
                              staticClass: "custom-table",
                              attrs: {
                                data: _vm.orderDetail.auxiliaryInfoList.meal,
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "乘机人",
                                  prop: "passengerName",
                                  width: "150px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "餐食类型",
                                  prop: "mealType",
                                  width: "120px",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "价格",
                                  prop: "price",
                                  width: "120px",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm._v(
                                            _vm._s(scope.row.price || "-")
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1787087901
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单退款",
            visible: _vm.refundDialogVisible,
            width: "500px",
            "close-on-click-modal": false,
            "custom-class": "refund-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  title: "请注意",
                  type: "warning",
                  description: "退款操作将影响订单状态，请谨慎操作",
                  closable: false,
                  "show-icon": "",
                },
              }),
              _c(
                "el-form",
                {
                  ref: "refundForm",
                  attrs: {
                    model: _vm.refundForm,
                    rules: _vm.refundRules,
                    "label-width": "100px",
                    size: "medium",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "退款金额", prop: "refundAmount" } },
                    [
                      _c(
                        "el-input",
                        {
                          attrs: {
                            placeholder: "请输入退款金额",
                            type: "number",
                            "prefix-icon": "el-icon-money",
                          },
                          model: {
                            value: _vm.refundForm.refundAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.refundForm, "refundAmount", $$v)
                            },
                            expression: "refundForm.refundAmount",
                          },
                        },
                        [
                          _c("template", { slot: "append" }, [
                            _vm._v(_vm._s(_vm.orderDetail.currency || "CNY")),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: {
                    click: function ($event) {
                      _vm.refundDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    icon: "el-icon-check",
                  },
                  on: { click: _vm.handleRefund },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "page-title" }, [
      _c("i", { staticClass: "el-icon-document" }),
      _vm._v(" 订单详情 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }